import React, { memo } from 'react';

export default memo((props: any) => (

<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
  <g fill="none" fillRule="evenodd">
    <path fill="#041E42"
      d="M8 42V18L24.1 6 40 18v24H28.3V27.75h-8.65V42Zm3-3h5.65V24.75H31.3V39H37V19.5L24.1 9.75 11 19.5Zm13-14.65Z" />
  </g>
</svg>

))
